import React, { useState } from 'react';
import { Box, Typography, Button, Modal, Paper } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import Layout from 'components/Layout/Layout';
import WorkOrderCalendar from 'components/Calendar/WorkOrderCalendar';
import WorkOrderForm from 'components/WorkOrder/WorkOrderForm';
import axios from 'api/axiosConfig';

const fetchMechanics = async () => {
  const { data } = await axios.get('/users?role=mechanic');
  return data;
};

const CalendarPage = () => {
  const [openForm, setOpenForm] = useState(false);
  const queryClient = useQueryClient();

  const { data: mechanics, isLoading, error } = useQuery({
    queryKey: ['users', 'mechanic'],
    queryFn: fetchMechanics,
  });

  if (isLoading) return <Layout><Typography>Loading...</Typography></Layout>;
  if (error) console.error('Mechanics fetch error:', error);

  return (
    <Layout>
      <Box sx={{ mb: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="h4" fontWeight={600}>Work Orders Calendar</Typography>
          <Typography variant="body1" color="textSecondary">Drag and drop to reschedule work orders</Typography>
        </Box>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpenForm(true)}>
          New Work Order
        </Button>
      </Box>

      <WorkOrderCalendar />

      <Modal open={openForm} onClose={() => setOpenForm(false)}>
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          maxWidth: '90%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          maxHeight: '90vh',
          overflow: 'auto'
        }}>
          <WorkOrderForm
            mechanics={mechanics || []}
            onSuccess={() => {
              setOpenForm(false);
              queryClient.invalidateQueries(['workorders']);
            }}
            onCancel={() => setOpenForm(false)}
          />
        </Box>
      </Modal>
    </Layout>
  );
};

export default CalendarPage;